import type { DraftMessageId } from "@redotech/effect-api-shared/ids/definitions";
import type { DraftMessageStatus } from "@redotech/effect-api-shared/models/shopper-ai/conversation/draft";

export interface DraftSendStatusPatch {
  id: DraftMessageId;
  status: DraftMessageStatus;
}

export function markDraftSending(
  draftId: DraftMessageId,
): DraftSendStatusPatch {
  return { id: draftId, status: "SENDING" };
}

export function restoreDraftPending(
  draftId: DraftMessageId,
): DraftSendStatusPatch {
  return { id: draftId, status: "PENDING" };
}
